export class FindingExclusionResourceFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "isAccountWide",
            "baseName": "isAccountWide",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return FindingExclusionResourceFilter.attributeTypeMap;
    }
    constructor() {
    }
}
